//////////
// Detect Touch Device
//////////
const isTouchDevice =
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0;

//////////
// Initialize Parallax Images (Desktop Only)
//////////
let ukiyo = null;
if (!isTouchDevice) {
  const parallax = document.querySelectorAll('.parallax');

  if (parallax.length) {
    ukiyo = new Ukiyo(parallax, {
      scale: 1.2,
      speed: 1.2,
      willChange: true,
      wrapperClass: "parallax-wrapper",
      externalRAF: true
    });
  }
}


//////////
// Initialize Lenis
//////////
const lenis = new Lenis();
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => {
    if (!document.body.classList.contains('noScroll')) {
        lenis.raf(time * 1000);
    }
    if (ukiyo) {
        ukiyo.animate();
    }
});
gsap.ticker.lagSmoothing(0);


//////////
// Hero Animation
//////////
document.addEventListener('DOMContentLoaded', () => {

	let hasAnimated = false;

	function loadingAnimation() {

		if (hasAnimated) return;
		hasAnimated = true;

        const logo = document.getElementById('sabliere-logo');
        const logoReveal = document.getElementById('anim-reveal');
		const mask = document.getElementById('animatedHero-mask');
		const introContent = document.getElementById('animatedHero-content');
        const header = document.getElementById('header-component');

		if (!logo|| !logoReveal || !mask || !introContent || !header) return;

		const isDesktop = window.innerWidth >= 1024;
		const maskSize = isDesktop ? '100vw' : '100vh';

		const tl = gsap.timeline({
			onComplete: function() {
				document.body.classList.remove('noScroll');
				mask.classList.add('complete');
			}
		});

		tl.to(logo, {
			delay: 0.3,
			duration: 1.4,
			opacity: 1,
			ease: "expo.inOut"
		})
		.to(logoReveal, {
			duration: 0.6,
			height: 0,
			ease: "power3.inOut"
		}, ">-0.3")
		.to(mask, {
			delay: 0.6,
			duration: 2.5,
			'--mask-yPos': '100%',
			ease: "expo.inOut"
		}, "<-1.5")
		.to(mask, {
			duration: 2,
			'--mask-size': maskSize,
			'--mask-overlay': '0.16',
			width: '100vw',
			height: '100vh',
			left: '0',
			top: '0',
			ease: "power3.inOut"
		}, ">-0.3")
		.to(introContent, {
			duration: 1,
			opacity: 1,
			ease: "expo.inOut",
		}, ">-1.2")
        .set(header, {
            pointerEvents: "all"
        }, "<")
        .to(header, {
            duration: 1,
            opacity: 1,
            ease: "expo.inOut",
        }, "<")
		.to(logo, {
			duration: 2,
			opacity: 0,
			ease: "expo.inOut",
		}, "2.3");

	}

	loadingAnimation();

});


//////////
// Split Text Testimonial
//////////
gsap.registerPlugin(ScrollTrigger, SplitText);
document.fonts.ready.then(setupSplits);

function setupSplits() {

    const targets = gsap.utils.toArray(".split-testimonial");
    targets.forEach((target) => {

        if (!target.closest('.animated-quote')) return;

        let SplitClient = new SplitText(target, {
            type: "lines",
            autoSplit: true,
            onSplit(self) {
                gsap.from(self.lines, {
                    scrollTrigger: {
                        trigger: target,
                        //markers: true,
                        start: "top 80%",
                        end: "bottom center"
                    },
                    duration: 0.8,
                    opacity: 0,
                    filter: "blur(2px)",
                    y: 14,
                    ease: "expo.inOut",
                    stagger: 0.3,
                    //onComplete: () => self.revert()
                });
            }
        });

    });

}


//////////
// Gsap Match Media
//////////
let mm = gsap.matchMedia();
const footerContent = document.querySelector("footer .sab-grid");

mm.add("(min-width: 768px)", () => {

    //////////
    // Footer Parralax Reveal
    //////////
    ScrollTrigger.create({
        trigger: "footer",
        start: "top bottom",
        end: "bottom bottom",
        scrub: true,
        onUpdate: (self) => {
            const progress = self.progress;
            const yValue = -35 * (1 - progress);
            gsap.set(footerContent, {y: `${yValue}%`});
        }
    });

    //////////
    // Image Reveals
    //////////
    ScrollTrigger.batch(".reveal", {
        start: "top 50%",
        //markers: true,
        onEnter: elements => gsap.to(elements, {
            duration: 1,
            scaleY: 0,
            transformOrigin: "bottom",
            ease: "power2.inOut",
            stagger: 0.2
        })
    });

  return () => {};

});


//////////
// Footer - Mark.riv Animation
//////////
const mark = new rive.Rive({
    src: "https://cdn.shopify.com/s/files/1/1009/2707/8739/files/Sabliere_mark_reveal.riv?v=1772797743",
    canvas: document.getElementById("mark-image"),
    autoplay: false,
    onLoad: () => {
        mark.resizeDrawingSurfaceToCanvas();
        // const file = mark.contents;
        // const artboardNames = file.artboards.map(artboard => artboard.name);
        // console.log(artboardNames);
    },
    onComplete: () => {
        mark.cleanup();
    }
});

let markPlayed = false;

ScrollTrigger.create({
  trigger: "footer",
  start: "top 50%",
  once: true,
  //markers: true,
  invalidateOnRefresh: true,
  onEnter: () => {
    if (!markPlayed) {
      mark.play();
      markPlayed = true;
    }
  },
});